export default {
  enumerableLists: [
    {
      text: 'ADD-新增',
      value: 'A',
    }, {
      text: 'MODIFY-修改',
      value: 'M',
    }, {
      text: 'DELETE-删除',
      value: 'D',
    }, {
      text: 'QUERY-查询',
      value: 'Q',
    }, {
      text: 'SUBMIT-提交',
      value: 'S',
    }, {
      text: 'VOID-作废',
      value: 'V',
    }, {
      text: 'UNSUBMIT-取消提交',
      value: 'U',
    }, {
      text: 'BATCH-批量修改',
      value: 'B',
    },
  ],
  strictMode: false
};
